import React, { FunctionComponent } from 'react';

import { CheckboxFieldType } from '../../types';
import { CheckboxTypeEnum } from '../../enums';
import { Field } from 'formik';
import classNames from 'classnames';

const CheckboxField: FunctionComponent<CheckboxFieldType> = ({
  formikProps,
  name,
  label,
  required,
  disabled,
  type = CheckboxTypeEnum.DEFAULT,
  ...props
}) => {
  return (
    <div className={classNames('form-check', type === CheckboxTypeEnum.SWITCH && 'form-switch')}>
      <Field
        type="checkbox"
        name={name}
        id={`checkbox-field-${name}`}
        className={classNames('form-check-input', formikProps.touched?.[name] && formikProps.errors?.[name] && 'is-invalid')}
        disabled={disabled || formikProps.isSubmitting}
        {...props}
      />
      <label
        htmlFor={`checkbox-field-${name}`}
        className={classNames(
          'ms-1',
          'form-check-label',
          formikProps.touched?.[name] && formikProps.errors?.[name] && 'text-danger',
        )}
      >
        {label}
        {required && <span className="text-danger"> *</span>}
      </label>
      {formikProps.touched?.[name] && formikProps.errors?.[name] && (
        <div className="invalid-feedback">
          <>{formikProps.errors[name]}</>
        </div>
      )}
    </div>
  );
};

export default CheckboxField;
